module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "500px",
      "margin": "auto"
    },
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('div', {
    staticClass: "selectSpec"
  }, [_vm._l((_vm.form.frontendPropertyInfo), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "searchtree-item"
    }, [_c('div', {
      staticClass: "searchtree-label"
    }, [_vm._v(_vm._s(item.name) + "：")]), _vm._v(" "), _c('ul', {
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, _vm._l((item.propertyDetails), function(p, j) {
      return _c('li', {
        key: j,
        class: ["item", p.current ? "on" : ""],
        on: {
          "click": function($event) {
            return _vm.selAttr(i, j)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(p.name) + "\n                 ")])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "searchtree-item"
  }, [_c('div', {
    staticClass: "searchtree-label-num"
  }, [_vm._v("数量：")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('li', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "reduceNum no-select",
    on: {
      "click": _vm.reduceNum
    }
  }, [_vm._v("\n                      -\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.num),
      expression: "num"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.stockNum <= 0
    },
    domProps: {
      "value": (_vm.num)
    },
    on: {
      "change": _vm.changeNum,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.num = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "addNum no-select",
    on: {
      "click": _vm.addNum
    }
  }, [_vm._v("\n                      +\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "no-select"
  }, [_vm._v("库存剩余(" + _vm._s(_vm.stockNum) + ")")])])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("加入购物车")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1384ae94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/components/SelectSpec.vue
// module id = 742
// module chunks = 2